export default class Helpers {
  static NESTED_FORM_SCHEMA_KEYS = ['columns', 'rows', 'components', 'headerComponents'];

  public static trimRecursiveObj(data: any) {
    if (Array.isArray(data)) {
      for (let i = 0; i < data.length; i++) {
        data[i] = Helpers.trimRecursiveObj(data[i]);
      }
    } else if (data != null && typeof data === "object") {
      for (const key of Object.keys(data)) {
        data[key] = Helpers.trimRecursiveObj(data[key]);
      }
    } else if (typeof data === "string") {
      data = data.trim();
    }
    return data;
  }

  private static stripParagraphWrapper(value: string): string {
    if (!value || typeof value !== 'string') { return value; }
    return value.replace(/^<p>([\s\S]*?)<\/p>$/i, '$1').trim();
  }

  public static stripCKEditorParagraphWrapper(schema: any) {
    if (!schema) { return; }
    if (Array.isArray(schema)) {
      schema.forEach(s => Helpers.stripCKEditorParagraphWrapper(s));
      return;
    }
    if ((schema.type === 'radio' || schema.type === 'selectboxes') && Array.isArray(schema.values)) {
      schema.values.forEach(v => {
        if (v.label) { v.label = Helpers.stripParagraphWrapper(v.label); }
      });
    }
    if (schema.type === 'checkbox' && schema.label) {
      schema.label = Helpers.stripParagraphWrapper(schema.label);
    }
    for (const key of Helpers.NESTED_FORM_SCHEMA_KEYS) {
      if (Array.isArray(schema[key])) {
        Helpers.stripCKEditorParagraphWrapper(schema[key]);
      }
    }
  }

  public static validateFormSchema(schema: any, _keys?: string[], parentSchema?: any) {
    if (!schema) {
      return false;
    }
    if (!Array.isArray(_keys)) {
      _keys = [];
    }
    let result: any = true;
    if (Array.isArray(schema)) {
      for (const subSchema of schema) {
        const subResult = Helpers.validateFormSchema(subSchema, _keys, parentSchema);
        if (Array.isArray(subResult)) {
          if (Array.isArray(result)) {
            result.push(...subResult);
          }
          else {
            result = subResult;
          }
        }
      }
      return result;
    }
    if (schema.key) {
      if (_keys.includes(schema.key)) {
        if (!parentSchema || !(parentSchema.type === 'columns' && schema.type === 'column')) {
          result = [
            {
              key: schema.key,
              message: 'Duplicate key',
              code: 'DUPLICATE_KEY'
            }
          ];
        }
      }
      else {
        _keys.push(schema.key);
      }
    }
    if (schema.type === 'file' && schema.defaultValue) {
      delete schema.defaultValue;
    }
    for (const key of Helpers.NESTED_FORM_SCHEMA_KEYS) {
      if (Array.isArray(schema[key])) {
        const subResult = Helpers.validateFormSchema(schema[key], _keys, schema);
        if (Array.isArray(subResult)) {
          if (Array.isArray(result)) {
            result.push(...subResult);
          }
          else {
            result = subResult;
          }
        }
      }
    }
    return result;
  }

  public static generateValidationErrorMessages(items: any[]) {
    return items.map(item => `${item.key} - ${item.message}`);
  }

  public static getBotServiceNamePrefix(serviceId: string) {
    if (serviceId) {
      const lastOpen = serviceId.lastIndexOf('(');
      if (lastOpen === -1) {
        return serviceId;
      }
      const lastClose = serviceId.indexOf(')', lastOpen);
      if (lastClose === -1) {
        return serviceId;
      }
      return serviceId.substring(0, lastOpen);
    }
    return '';
  }

  public static getBotServiceNameSuffix(serviceId: string) {
    if (serviceId) {
      const lastClose = serviceId.lastIndexOf(')');
      if (lastClose === -1) {
        return serviceId;
      }
      let ret = serviceId.substring(lastClose + 1);
      if (ret.startsWith('-')) {
        ret = ret.substring(1);
      }
      return ret;
    }
    return '';
  }

  public static getBotServiceVersion(serviceId: string) {
    if (serviceId) {
      const lastOpen = serviceId.lastIndexOf('(');
      if (lastOpen === -1) {
        return null;
      }
      const lastClose = serviceId.indexOf(')', lastOpen);
      if (lastClose === -1) {
        return null;
      }
      return Number(serviceId.substring(lastOpen + 1, lastClose));
    }
    return null;
  }
}
